import { render, staticRenderFns } from "./page-content.vue?vue&type=template&id=08f6912c&scoped=true&"
import script from "./page-content.vue?vue&type=script&lang=js&"
export * from "./page-content.vue?vue&type=script&lang=js&"
import style0 from "./page-content.vue?vue&type=style&index=0&id=08f6912c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6912c",
  null
  
)

export default component.exports